module.exports = __webpack_public_path__ + "static/media/type_d.562e9bf6.png";